const FACET_DIMENSIONS = {
  productType: 'product',
  scene: 'scene',
  contentType: 'category',
  stage: 'stage',
}

const countFor = (counts, value, stage) => {
  const key =
    stage && (value === 1 || value === '1')
      ? 'PRE_SALE'
      : stage && (value === 2 || value === '2')
        ? 'AFTER_SALE'
        : String(value)
  return Number(counts?.[key]) || 0
}

export const filterServiceFacetOptions = (options, counts, wildcardCount = 0, stage = false) =>
  (Array.isArray(options) ? options : []).flatMap((option) => {
    const children = Array.isArray(option.children) ? option.children : []
    if (children.length > 0) {
      const visibleChildren = filterServiceFacetOptions(children, counts, wildcardCount, stage)
      return visibleChildren.length ? [{ ...option, children: visibleChildren }] : []
    }
    if (String(option.value).startsWith('group_')) return []
    return countFor(counts, option.value, stage) + wildcardCount > 0 ? [option] : []
  })

export const filterServiceFacetGroups = (groups, facets) => {
  if (!facets) return groups
  return (Array.isArray(groups) ? groups : []).flatMap((group) => {
    const dimension = FACET_DIMENSIONS[group.id]
    if (!dimension) return [group]
    const wildcard = dimension === 'product' ? Number(facets.productWildcardCount) || 0 : 0
    const options = filterServiceFacetOptions(
      group.options,
      facets[dimension],
      wildcard,
      dimension === 'stage'
    )
    return options.length ? [{ ...group, options }] : []
  })
}

export const hasServiceFacetOption = (groups, groupId, selected) => {
  const group = groups.find((item) => item.id === groupId)
  const hasValue = (options) =>
    options.some(
      (option) => String(option.value) === String(selected) || hasValue(option.children || [])
    )
  return Boolean(group && hasValue(group.options || []))
}
